export default "__VITE_ASSET__DWZI6aII__"